import { RumEvent } from '@datadog/browser-rum';

/**
 * Interim noise filter for RUM error tracking.
 *
 * Latent/unused Google Ads tags (conversion ID 984292306) still fire on the portal
 * via GTM (container GTM-NS64KQZ) and are correctly blocked by our CSP, generating
 * ~38k CSP-violation errors. Marketing confirmed these are historical and unused; the
 * permanent fix is a GTM cleanup (owner: marketing). Until then we discard RUM
 * errors for these two specific hosts only, so every OTHER CSP violation still surfaces
 * (an unexpected blocked script can indicate XSS/injection).
 *
 * Remove this filter once the GTM tags are cleaned up.
 */
export const IGNORED_CSP_VIOLATION_HOSTS = ['www.google.com/rmkt/collect', 'googleads.g.doubleclick.net'] as const;

/**
 * Returns true when a RUM event should be dropped (not sent to Datadog).
 */
export function shouldDiscardRumEvent(event: RumEvent): boolean {
    if (event.type !== 'error') {
        return false;
    }

    const message = (event as RumEvent & { error?: { message?: string } }).error?.message;

    return (
        typeof message === 'string' &&
        message.includes('csp_violation') &&
        IGNORED_CSP_VIOLATION_HOSTS.some(host => message.includes(host))
    );
}
